import { Model, Attr, HasOne, BelongsTo } from 'spraypaint';
import { NullProxy, RecordProxy } from 'spraypaint/lib-esm/proxies';
import ApplicationRecord from 'spa-ionata-admin/lib/models/ApplicationRecord';
import User from './User';
import Media from './Media';
import Business from './Business';
import DraftBusiness from './DraftBusiness';

export type AwardProxy = RecordProxy<Award> | NullProxy<Award>;

@Model()
export default class Award extends ApplicationRecord {
  static jsonapiType = 'awards';

  // --- Attributes
  // --------------

  // required
  @Attr() title!: string;

  // nullable
  @Attr() subtitle!: string | null;

  // readOnly
  @Attr() createdAt!: string | null;

  // readOnly
  @Attr() modifiedAt!: string | null;

  // --- Relationships
  // -----------------

  @BelongsTo() business!: Business;

  @BelongsTo() draftBusiness!: DraftBusiness;

  // nullable
  @HasOne() image!: Media | null;

  // nullable
  @HasOne() createdBy!: User | null;

  // nullable
  @HasOne() modifiedBy!: User | null;

  get imageProcessUrl() {
    return this.id ? this.klass.url(this.id, 'image/') : undefined;
  }
}
